import http from './request';

export async function getProvinceCity(data = {}) {
    return http({
        url: '/backend/web/static/js/city.json',
        data,
        methods: 'GET',
        loading: false,
    });
}

// 55.协议详情
export async function getProtocolInfo(data = {}) {
    return http({
        url: 'protocol/info',
        params: data,
        method: 'GET',
        loading: true,
    });
}


export async function userWxLogin(data = {}) {
    return http({
        url: 'user/wx-login',
        params: data,
        method: 'GET',
        loading: true,
    });
}

export async function getUserMpSing(data = {}) {
    return http({
        url: 'user/mp-sign',
        params: data,
        method: 'GET',
        loading: false,
    });
}

export async function getUserInfo(data = {}) {
    return http({
        url: 'user/info',
        params: data,
        method: 'GET',
        loading: true
    })
}

